<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img class="logoimage" src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="address_tel_fax">
      <span>Tel：0551-63362663</span>
    </p>
    <p class="email_wx">
      <span>公司地址：合肥市包河区望江东路60号水泥研究设计院内智烁智联数字科技产业园401</span>
    </p>
    <div class="copyright">
      安徽赛尔斯信息科技有限公司 | 版权所有 <a href="https://beian.miit.gov.cn/" style="color:#d3d3d3;" target="_blank"
                                               rel="nofollow">皖ICP备18007851号</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}

.logo {
  width: 135px;
  height: 45px;
  margin: 20px auto 20px;

  .logoimage {
    width: 135px;
    height: 45px;
  }
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copyright {
  a {
    color: #d3d3d3;
  }

  color: #d3d3d3;
  font-size: 14px;
}

@media screen and (max-width: 997px) {

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue